import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';

import maintenanceIcon from 'assets/images/appInMaintenanceIcon.png'
import "./MaintenanceOverlay.scss";

import { getCustomerQRCodeData } from 'utils';

const QR_CODE_REFRESH_INTERVAL = 5 * 60 * 1000;

function CustomerMemberQrCode({ uid, memberShipID, displayName, isLogin }) {
  const [qrCodeString, setQRCodeString] = useState('');
  const [refreshDatetime, setRefreshDatetime] = useState(Date.now());

  useEffect(() => {
    const intervalID = setInterval(() => {
      setRefreshDatetime(Date.now());
    }, QR_CODE_REFRESH_INTERVAL);

    return () => {
      if (!!intervalID) {
        clearInterval(intervalID);
      }
    };
  }, []);

  useEffect(() => {
    if (!memberShipID || !refreshDatetime) {
      return;
    }
    const codeString = getCustomerQRCodeData(uid, memberShipID, refreshDatetime);
    setQRCodeString(codeString);
  }, [refreshDatetime, memberShipID, uid]);

  if (!isLogin) {
    return <></>
  }

  return (
    <div className="member-info-container">
      <div className="qr-code-container">
        <p className="member-title title-small">{displayName}</p>
        <p className="membership-id body-2">ID: {memberShipID}</p>
        <div className="maintenance-qr-code-content">
          {qrCodeString ? <QRCode value={qrCodeString} size={146} /> : null}
        </div>
      </div>
      <div className="split-line" />
    </div>
  );
}

const memberMapStateToProps = (state) => {
  return {
    uid: state.users.userInfo?.uid,
    memberShipID: state.users.userInfo?.memberShipID,
    displayName: state.users.displayName,
    isLogin: state.users.isLogin,
  }
}

const CustomerInfo = connect(memberMapStateToProps)(CustomerMemberQrCode)

function MaintenanceOverlay({ maintenanceInfo }) {
  const active = maintenanceInfo?.active
  const title = maintenanceInfo?.title
  const description = maintenanceInfo?.description
  useEffect(() => {
    if (active) {
      document.body.classList.add("maint-no-scroll");
      return () => {
        document.body.classList.remove("maint-no-scroll");
      };
    }
  }, [active]);
  
  if (!active) {
    return <></>
  }
  return (
    <div className="maint-overlay">
      <div className="maint-modal" role="dialog" aria-modal="true">
        <CustomerInfo />
        <img src={maintenanceIcon} alt="" className="maint-icon" />
        <label className="subheading maint-title">{title}</label>
        <label className="body-1 maint-desc">{description}</label>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    maintenanceInfo: state.enforceApp.maintenanceInfo,
  }
}

export default connect(mapStateToProps)(MaintenanceOverlay)